import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectNestedErrorUuids } from 'services/error/selectors';

// Types
import { Namespace } from 'types';
import { AppState } from 'services/types';

export interface OwnProps {
    namespace: Namespace;
    component?: React.ComponentType<any>;
}

interface ConnectedProps {
    nestedErrorUuids?: string[];
}

type Props = OwnProps & ConnectedProps;

/**
 * Takes an array of uuids that have corresponding errors and passes them into the component provided.
 * Usefull for creating custom error line items based on the generic error stucture.
 */
export class NestedErrorUuids extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { component, nestedErrorUuids } = this.props;

        if (!nestedErrorUuids || !nestedErrorUuids.length || !component) {
            return null;
        }
        return (
            <React.Fragment>
                {nestedErrorUuids.map(nestedErrorUuid =>
                    React.createElement(component, {
                        key: nestedErrorUuid,
                        uuid: nestedErrorUuid
                    })
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    nestedErrorUuids: makeSelectNestedErrorUuids()
});

export default connect(mapStateToProps)(NestedErrorUuids);
